import { render } from "./GameGuideComponent.vue?vue&type=template&id=7c3fb13a&scoped=true"
import script from "./GameGuideComponent.vue?vue&type=script&lang=js"
export * from "./GameGuideComponent.vue?vue&type=script&lang=js"

import "./GameGuideComponent.vue?vue&type=style&index=0&id=7c3fb13a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3fb13a"]])

export default __exports__